export const extraBadWords = [
  '2 girls 1 cup',
  '2g1c',
  '5ht',
  '666',
  '@$$',
  'a s s',
  'a s shole',
  'a55hole',
  'abbo',
  'abeed',
  'abuse',
  'acrotomophilia',
  'aeolus',
  'africoon',
  'alabama hot pocket',
  'alaskan pipeline',
  'alligator bait',
  'alligatorbait',
  'analannie',
  'analprobe',
  'analsex',
  'anilingus',
  'apeshit',
  'arabush',
  'arabushs',
  'areola',
  'areole',
  'argie',
  'arian',
  'armo',
  'armos',
  'aroused',
  'arsehole',
  'aryan',
  'assbag',
  'assbagger',
  'assbandit',
  'assbang',
  'assbanged',
  'assbanger',
  'assbangs',
  'assbite',
  'assblaster',
  'assclown',
  'asscock',
  'asscowboy',
  'asscracker',
  'assfuck',
  'assgoblin',
  'asshat',
  'asshead',
  'assho1e',
  'asshopper',
  'asshore',
  'assjacker',
  'assjockey',
  'asskiss',
  'asskisser',
  'assklown',
  'asslick',
  'asslicker',
  'asslover',
  'assman',
  'assmaster',
  'assmonkey',
  'assmunch',
  'assmuncher',
  'assnigger',
  'asspacker',
  'asspirate',
  'asspuppies',
  'assranger',
  'assshit',
  'assshole',
  'asssucker',
  'asswad',
  'asswhore',
  'asswipes',
  'auto erotic',
  'autoerotic',
  'azazel',
  'azz',
  'b a s t a r d',
  'b i t c h',
  'b o o b',
  'b!tchin',
  'b*tch',
  'b00b',
  'b00bies',
  'b00biez',
  'b00bz',
  'b7ch',
  'babe',
  'babeland',
  'babes',
  'baby batter',
  'baby juice',
  'backdoor',
  'backdoorman',
  'badfuck',
  'bagging',
  'ball gag',
  'ball gravy',
  'ball kicking',
  'ball licking',
  'ball sack',
  'ball sucking',
  'balllicker',
  'bampot',
  'bang',
  'bangbro',
  'bangbros',
  'bangbus',
  'banger',
  'banging',
  'bareback',
  'barely legal',
  'barelylegal',
  'barenaked',
  'barf',
  'barface',
  'barfface',
  'bassterd',
  'bastardo',
  'bastinado',
  'bawdy',
  'bazongas',
  'bazooms',
  'bbw',
  'bdsm',
  'beaner',
  'beaners',
  'beaney',
  'beaneys',
  'beardedclam',
  'beastality',
  'beastility',
  'beatch',
  'beater',
  'beatoff',
  'beatyourmeat',
  'beaver',
  'beaver cleaver',
  'beaver lips',
  'beef curtains',
  'beer',
  'beeyotch',
  'beotch',
  'bi curious',
  'bicurious',
  'big black',
  'big knockers',
  'bigass',
  'bigbastard',
  'bigbreasts',
  'bigbutt',
  'bigtits',
  'bimbo',
  'bimbos',
  'bint',
  'birdlock',
  'bitchass',
  'bitched',
  'bitchez',
  'bitchslap',
  'bitchtit',
  'bitchy',
  'biteme',
  'bitties',
  'blackcock',
  'blackman',
  'blackout',
  'blacks',
  'blonde action',
  'blonde on blonde',
  'blonde on blonde action',
  'bloodclaat',
  'blow',
  'blow j',
  'blow your l',
  'blow your load',
  'blue waffle',
  'bluegum',
  'bluegums',
  'blumpkin',
  'bo ob',
  'bo obs',
  'boang',
  'boche',
  'boches',
  'bod',
  'bodily',
  'bogan',
  'bohunk',
  'boink',
  'bollick',
  'bollocks',
  'bollox',
  'bombers',
  'bombing',
  'bomd',
  'bondage',
  'bone',
  'boned',
  'boners',
  'bong',
  'boobie',
  'boobies',
  'booby',
  'boobz',
  'booger',
  'bookie',
  'boong',
  'boonga',
  'boongas',
  'boongs',
  'boonie',
  'boonies',
  'bootee',
  'bootie',
  'bootlip',
  'bootlips',
  'booty',
  'booty call',
  'booze',
  'boozer',
  'boozy',
  'bosch',
  'bosche',
  'bosches',
  'boschs',
  'bosom',
  'bosomy',
  'bounty bar',
  'bounty bars',
  'bountybar',
  'bowel',
  'bowels',
  'bra',
  'brassiere',
  'brea5t',
  'breast',
  'breastjob',
  'breastlover',
  'breastman',
  'brown shower',
  'brown showers',
  'brunette action',
  'btch',
  'buddhahead',
  'buddhaheads',
  'buffies',
  'buggered',
  'buggery',
  'bukake',
  'bukkake',
  'bule',
  'bules',
  'bullcrap',
  'bulldike',
  'bulldyke',
  'bullet vibe',
  'bullshit',
  'bullshits',
  'bullshitted',
  'bullturds',
  'bumblefuck',
  'bumfuck',
  'bung',
  'bung hole',
  'bunga',
  'bungas',
  'bunghole',
  'burr head',
  'burr heads',
  'burrhead',
  'burrheads',
  'busty',
  'butchbabes',
  'butchdike',
  'butchdyke',
  'buttbang',
  'buttcheeks',
  'buttface',
  'buttfuck',
  'buttfucker',
  'buttfuckers',
  'butthead',
  'buttman',
  'buttmunch',
  'buttmuncher',
  'buttons',
  'buttpirate',
  'buttstain',
  'byatch',
  'c u n t',
  'c-0-c-k',
  'c-o-c-k',
  'c-u-n-t',
  'c.0.c.k',
  'c.o.c.k.',
  'c.u.n.t',
  'caca',
  'cacker',
  'cahone',
  'camel jockey',
  'camel jockeys',
  'camel toe',
  'cameljockey',
  'cameltoe',
  'camgirl',
  'camslut',
  'camwhore',
  'carpetmuncher',
  'carruth',
  'cervix',
  'chav',
  'cheese eating surrender monkey',
  'cheese eating surrender monkies',
  'cheeseeating surrender monkey',
  'cheeseeating surrender monkies',
  'cheesehead',
  'cheeseheads',
  'cherrypopper',
  'chickslick',
  'china swede',
  'china swedes',
  'chinaman',
  'chinamen',
  'chinaswede',
  'chinaswedes',
  'chinc',
  'chincs',
  'ching chong',
  'ching chongs',
  'chinga',
  'chingchong',
  'chingchongs',
  'chinks',
  'chinky',
  'choad',
  'chocolate rosebuds',
  'chode',
  'chodes',
  'chonkies',
  'chonky',
  'chonkys',
  'christ killer',
  'christ killers',
  'chug',
  'chugs',
  'chunger',
  'chungers',
  'chunkies',
  'chunkys',
  'chute',
  'circlejerk',
  'clamdigger',
  'clamdiver',
  'clamps',
  'clansman',
  'clansmen',
  'clanswoman',
  'clanswomen',
  'cleveland steamer',
  'climax',
  'clitface',
  'clitfuck',
  'clitorus',
  'clitty',
  'clogwog',
  'clover clamps',
  'clusterfuck',
  'cocain',
  'cocaine',
  'cockbite',
  'cockblock',
  'cockblocker',
  'cockburger',
  'cockcowboy',
  'cockfight',
  'cockfucker',
  'cockholster',
  'cockjockey',
  'cockknob',
  'cockknocker',
  'cockknoker',
  'cocklicker',
  'cocklover',
  'cockmaster',
  'cockmongler',
  'cockmongruel',
  'cockmonkey',
  'cocknob',
  'cocknose',
  'cocknugget',
  'cockqueen',
  'cockrider',
  'cockshit',
  'cocksman',
  'cocksmith',
  'cocksmoker',
  'cocksucer',
  'cocktease',
  'cocky',
  'cohee',
  'coital',
  'coitus',
  'commie',
  'condom',
  'coochie',
  'coochy',
  'coolie',
  'coolies',
  'cooly',
  'coonass',
  'coonasses',
  'coondog',
  'coons',
  'cooter',
  'coprolagnia',
  'coprophilia',
  'copulate',
  'corksucker',
  'cornhole',
  'cra5h',
  'crabs',
  'crack',
  'crackcocain',
  'cracker',
  'crackpipe',
  'crackwhore',
  'crapola',
  'crapper',
  'crappy',
  'crash',
  'creampie',
  'crotch',
  'crotchjockey',
  'crotchmonkey',
  'crotchrot',
  'cuck',
  'cumbubble',
  'cumdumpster',
  'cumfest',
  'cumguzzler',
  'cuming',
  'cumjockey',
  'cumlickr',
  'cumm',
  'cummin',
  'cumquat',
  'cumqueen',
  'cumshots',
  'cumslut',
  'cumstain',
  'cumsucker',
  'cumtart',
  'cunn',
  'cunnie',
  'cunntt',
  'cunny',
  'cunteyed',
  'cuntface',
  'cuntfuck',
  'cuntfucker',
  'cunthole',
  'cunthunter',
  'cuntrag',
  'cuntslut',
  'cuntsucker',
  'curry muncher',
  'curry munchers',
  'currymuncher',
  'currymunchers',
  'cushi',
  'cushis',
  'cybersex',
  'cyberslimer',
  'd0ng',
  'd0uch3',
  'd0uche',
  'd1ld0',
  'd1ldo',
  'dago',
  'dagos',
  'dahmer',
  'damm',
  'dammit',
  'damnation',
  'damned',
  'damnit',
  'darkey',
  'darkeys',
  'darkie',
  'darkies',
  'darky',
  'date rape',
  'daterape',
  'datnigga',
  'dawgie style',
  'dawgie-style',
  'deapthroat',
  'deep throat',
  'deep throating',
  'deepaction',
  'deepthroat',
  'deepthroating',
  'defecate',
  'deggo',
  'degos',
  'demon',
  'dendrophilia',
  'destroyyourpussy',
  'deth',
  'diaper daddy',
  'diaper head',
  'diaper heads',
  'diaperdaddy',
  'diaperhead',
  'diaperheads',
  'dickbag',
  'dickbeater',
  'dickbeaters',
  'dickbrain',
  'dickdipper',
  'dickface',
  'dickflipper',
  'dickforbrains',
  'dickfuck',
  'dickheads',
  'dickhole',
  'dickish',
  'dickjuice',
  'dickless',
  'dicklick',
  'dicklicker',
  'dickman',
  'dickmilk',
  'dickmonger',
  'dickpic',
  'dickripper',
  'dicks',
  'dicksipper',
  'dickslap',
  'dickslicker',
  'dicksucker',
  'dickwad',
  'dickweasel',
  'dickweed',
  'dickwhipper',
  'dickwod',
  'dickzipper',
  'diddle',
  'dike',
  'dilf',
  'diligaf',
  'dillweed',
  'dimwit',
  'dingle',
  'dingleberries',
  'dingleberry',
  'dipship',
  'dipshit',
  'dipstick',
  'dirty pillows',
  'dirty sanchez',
  'dix',
  'dixiedike',
  'dixiedyke',
  'dog style',
  'doggie',
  'doggie style',
  'doggie-style',
  'doggiestyle',
  'doggy style',
  'doggy-style',
  'doggystyle',
  'dolcett',
  'domination',
  'dommes',
  'dong',
  'donkey punch',
  'donkeypunch',
  'doochbag',
  'doodoo',
  'doofus',
  'dookie',
  'dopey',
  'dot head',
  'dot heads',
  'dothead',
  'dotheads',
  'double dong',
  'double penetration',
  'doubledong',
  'doublepenetration',
  'douch3',
  'douche',
  'douche bag',
  'douchebag',
  'douchebags',
  'douchewaffle',
  'douchey',
  'dp',
  'dp action',
  'dpaction',
  'dragqueen',
  'dragqween',
  'dripdick',
  'drunk',
  'dry hump',
  'dryhump',
  'dudette',
  'dumass',
  'dumbass',
  'dumbasses',
  'dumbbitch',
  'dumbfuck',
  'dumbshit',
  'dummy',
  'dumshit',
  'dune coons',
  'dvda',
  'dyefly',
  'dykes',
  'earotics',
  'easyslut',
  'eat my',
  'eatadick',
  'eatballs',
  'eathairpie',
  'eatme',
  'eatmyass',
  'eatpussy',
  'ecchi',
  'ekrem',
  'enlargement',
  'erect',
  'erection',
  'ero',
  'erotic',
  'erotism',
  'escort',
  'esqua',
  'essohbee',
  'eunuch',
  'evl',
  'excrement',
  'exkwew',
  'explosion',
  'extacy',
  'extasy',
  'f u k',
  'f*ck',
  'f-u-c-k',
  'f.u.c.k',
  'facefucker',
  'fack',
  'faeces',
  'fagbag',
  'fagfucker',
  'fagg',
  'fagged',
  'faggotcock',
  'fagt',
  'fagtard',
  'faigt',
  'fannybandit',
  'farted',
  'farting',
  'fartknocker',
  'farty',
  'fastfuck',
  'fat',
  'fatah',
  'fatfuck',
  'fatfucker',
  'fatso',
  'fck',
  'fckcum',
  'fckd',
  'fecal',
  'felatio',
  'felch',
  'feltch',
  'feltcher',
  'feltching',
  'female squirting',
  'femalesquirtin',
  'femalesquirting',
  'femdom',
  'fetish',
  'figging',
  'fingerbang',
  'fingerfood',
  'fingering',
  'fisted',
  'fister',
  'fisting',
  'fisty',
  'fitt',
  'flamer',
  'flasher',
  'flogthelog',
  'floo',
  'floozy',
  'flydie',
  'flydye',
  'foad',
  'fok',
  'fondle',
  'foobar',
  'foot fetish',
  'footaction',
  'footfetish',
  'footfuck',
  'footfucker',
  'footjob',
  'footlicker',
  'footstar',
  'forni',
  'fornicate',
  'foursome',
  'fourtwenty',
  'freakfuck',
  'freakyfucker',
  'freefuck',
  'freex',
  'frigg',
  'frigga',
  'frigger',
  'frotting',
  'fubar',
  'fucck',
  'fuckable',
  'fuckass',
  'fuckbag',
  'fuckbitch',
  'fuckbook',
  'fuckboy',
  'fuckbrain',
  'fuckbuddy',
  'fuckbutt',
  'fuckd',
  'fuckedup',
  'fuckersucker',
  'fuckface',
  'fuckfest',
  'fuckfreak',
  'fuckfriend',
  'fuckher',
  'fuckhole',
  'fuckina',
  'fuckingbitch',
  'fuckinnuts',
  'fuckinright',
  'fuckit',
  'fuckknob',
  'fuckmeat',
  'fuckmehard',
  'fuckmonkey',
  'fuckn',
  'fucknugget',
  'fucknut',
  'fucknuts',
  'fucknutt',
  'fucknutz',
  'fuckoff',
  'fuckpig',
  'fuckpuppet',
  'fuckr',
  'fuckstick',
  'fucktard',
  'fucktards',
  'fucktoy',
  'fucktrophy',
  'fuckup',
  'fuckwad',
  'fuckwhore',
  'fuckwitt',
  'fuckyomama',
  'fuckyou',
  'fugly',
  'fuking',
  'fukking',
  'fuktard',
  'fuktards',
  'funeral',
  'funfuck',
  'fungus',
  'futanari',
  'futanary',
  'fuuck',
  'fuxor',
  'fvck',
  'fvk',
  'fxck',
  'g-spot',
  'gae',
  'gai',
  'gang bang',
  'gangbanger',
  'gangsta',
  'ganja',
  'gassyass',
  'gator bait',
  'gatorbait',
  'gay',
  'gayass',
  'gaybob',
  'gayboy',
  'gaydo',
  'gaygirl',
  'gaymuthafuckinwhore',
  'gays',
  'gaytard',
  'gaywad',
  'gayz',
  'geezer',
  'geni',
  'genital',
  'genitals',
  'getiton',
  'gey',
  'gfy',
  'ghay',
  'ghey',
  'gigolo',
  'ginzo',
  'ginzos',
  'gipp',
  'gippo',
  'gippos',
  'gipps',
  'girl on',
  'girl on top',
  'girls gone wild',
  'givehead',
  'glans',
  'glazeddonut',
  'goatcx',
  'gob',
  'godam',
  'godammit',
  'godamn',
  'godamnit',
  'goddam',
  'goddamit',
  'goddamm',
  'goddammit',
  'goddamnes',
  'goddamnit',
  'goddamnmuthafucker',
  'godsdamn',
  'gokkun',
  'golden shower',
  'goldenshower',
  'golliwog',
  'golliwogs',
  'gonad',
  'gonads',
  'gonorrehea',
  'gonzagas',
  'goo girl',
  'gooch',
  'goodpoop',
  'gookeye',
  'gookeyes',
  'gookies',
  'gooks',
  'gooky',
  'gora',
  'goras',
  'goregasm',
  'gotohell',
  'goy',
  'goyim',
  'greaseball',
  'greaseballs',
  'gringo',
  'gringos',
  'groe',
  'groid',
  'groids',
  'grope',
  'gross',
  'grostulation',
  'gspot',
  'gstring',
  'gtfo',
  'gub',
  'gubba',
  'gubbas',
  'gubs',
  'guido',
  'guineas',
  'guizi',
  'gummer',
  'guro',
  'gwailo',
  'gwailos',
  'gweilo',
  'gweilos',
  'gyopo',
  'gyopos',
  'gyp',
  'gyped',
  'gypo',
  'gypos',
  'gypp',
  'gypped',
  'gyppie',
  'gyppies',
  'gyppo',
  'gyppos',
  'gyppy',
  'gyppys',
  'gypsys',
  'h e l l',
  'h o m',
  'h0m0',
  'h0mo',
  'hadji',
  'hadjis',
  'hairyback',
  'hairybacks',
  'haji',
  'hajis',
  'hajji',
  'hajjis',
  'half breed',
  'half caste',
  'halfbreed',
  'halfcaste',
  'hamas',
  'hamflap',
  'hand job',
  'handjob',
  'haole',
  'haoles',
  'hapa',
  'hard core',
  'hard on',
  'hardcore',
  'hardon',
  'harem',
  'he11',
  'headfuck',
  'hebe',
  'hebes',
  'heeb',
  'heebs',
  'hemp',
  'hentai',
  'heroin',
  'herp',
  'herpes',
  'herpy',
  'hijacker',
  'hijacking',
  'hillbillies',
  'hillbilly',
  'hindoo',
  'hiscock',
  'hitler',
  'hitlerism',
  'hitlerist',
  'hiv',
  'ho',
  'hobag',
  'hodgie',
  'hoe',
  'hoes',
  'holestuffer',
  'hom0',
  'homey',
  'homicide',
  'homobangers',
  'homodumbshit',
  'homoerotic',
  'homoey',
  'honger',
  'honkers',
  'honkeys',
  'honkie',
  'honkies',
  'honky',
  'hooch',
  'hookah',
  'hooker',
  'hookers',
  'hootch',
  'hooter',
  'hooters',
  'hori',
  'horis',
  'hork',
  'horndawg',
  'horndog',
  'horney',
  'horseshit',
  'hosejob',
  'hoser',
  'hot carl',
  'hot chick',
  'hotcarl',
  'hotdamn',
  'hotpussy',
  'hottotrot',
  'how to kill',
  'how to murder',
  'howtokill',
  'howtomurdep',
  'huge fat',
  'hugefat',
  'hummer',
  'hump',
  'humped',
  'humper',
  'humpher',
  'humphim',
  'humpin',
  'humping',
  'hussy',
  'hustler',
  'hymen',
  'hymie',
  'hymies',
  'iblowu',
  'ike',
  'ikes',
  'ikey',
  'ikeymo',
  'ikeymos',
  'ikwe',
  'illegal',
  'illegals',
  'inbred',
  'incest',
  'indon',
  'indons',
  'injuns',
  'insest',
  'intercourse',
  'interracial',
  'intheass',
  'inthebuff',
  'israels',
  'j3rk0ff',
  'jack off',
  'jackass',
  'jackhole',
  'jackshit',
  'jacktheripper',
  'jail bait',
  'jailbait',
  'japcrap',
  'japie',
  'japies',
  'jebus',
  'jelly donut',
  'jerk',
  'jerk off',
  'jerk0ff',
  'jerked',
  'jerkoff',
  'jerries',
  // 'jerry',
  'jesuschrist',
  'jewed',
  'jewess',
  'jig',
  'jiga',
  'jigaboo',
  'jigaboos',
  'jigarooni',
  'jigaroonis',
  'jigg',
  'jigga',
  'jiggabo',
  'jiggaboo',
  'jiggabos',
  'jiggas',
  'jigger',
  'jiggerboo',
  'jiggers',
  'jiggs',
  'jiggy',
  'jigs',
  'jihad',
  'jijjiboo',
  'jijjiboos',
  'jimfish',
  'jizim',
  'jizin',
  'jizjuice',
  'jizn',
  'jizzd',
  'jizzed',
  'jizzim',
  'jizzin',
  'jizzn',
  'jizzum',
  'jugg',
  'juggs',
  'jugs',
  'jungle bunnies',
  'jungle bunny',
  'junglebunny',
  'junkie',
  'junky',
  'kacap',
  'kacapas',
  'kacaps',
  'kaffer',
  'kaffir',
  'kaffre',
  'kafir',
  'kanake',
  'kanker',
  'katsap',
  'katsaps',
  'khokhol',
  'khokhols',
  'kicking',
  'kigger',
  'kikes',
  'kill',
  'kimchis',
  'kinbaku',
  'kink',
  'kinkster',
  'kinky',
  'kinkyJesus',
  'kissass',
  'kiunt',
  'kkk',
  'klan',
  'klansman',
  'klansmen',
  'klanswoman',
  'klanswomen',
  'knobbing',
  'knockers',
  'kooch',
  'kooches',
  'koon',
  'kootch',
  'krap',
  'krappy',
  'krauts',
  'kuffar',
  'kumbubble',
  'kumbullbe',
  'kumer',
  'kumquat',
  'kunnilingus',
  'kushi',
  'kushis',
  'kusi',
  'kwa',
  'kwai lo',
  'kwai los',
  'kwif',
  'ky',
  'kyke',
  'kykes',
  'kyopo',
  'kyopos',
  'kyrpa',
  'lapdance',
  'lds',
  'leather restraint',
  'leather straight',
  'leather straight jacket',
  'leatherrestraint',
  'lebo',
  'lebos',
  'lech',
  'lemon party',
  'lemonparty',
  'len',
  'leper',
  'lesbain',
  'lesbayn',
  'lesbians',
  'lesbin',
  'lesbos',
  'lez',
  'lezbe',
  'lezbefriends',
  'lezbian',
  'lezbians',
  'lezbo',
  'lezbos',
  'lezz',
  'lezzie',
  'lezzies',
  'lezzo',
  'lezzy',
  'libido',
  'licker',
  'licking',
  'lickme',
  'lilniglet',
  'limey',
  'limpdick',
  'limy',
  'lingerie',
  'livesex',
  'lmao',
  'lmfao',
  'loadedgun',
  'loin',
  'loins',
  'lolita',
  'lovebone',
  'lovegoo',
  'lovegun',
  'lovejuice',
  'lovemaking',
  'lovemuscle',
  'lovepistol',
  'loverocket',
  'lowlife',
  'lsd',
  'lube',
  'lubejob',
  'lubra',
  'lucifer',
  'luckycammeltoe',
  'lugan',
  'lugans',
  'lusty',
  'lynch',
  'mabuno',
  'mabunos',
  'macaca',
  'macacas',
  'mafugly',
  'magicwand',
  'mahbuno',
  'mahbunos',
  'make me come',
  'makemecome',
  'makemecum',
  'male squirting',
  'mams',
  'manhater',
  'manpaste',
  'maricon',
  'maricón',
  'marijuana',
  'massa',
  'mastabate',
  'mastabater',
  'masterbat',
  'masterbat*',
  'masterbating',
  'masterblaster',
  'mastrabator',
  'masturbat',
  'masturbating',
  'masturbation',
  'mattressprincess',
  'mau mau',
  'mau maus',
  'maumau',
  'maumaus',
  'maxi',
  'mcfagget',
  'meatbeatter',
  'meatrack',
  'menage',
  'menage a trois',
  'menses',
  'menstruate',
  'menstruation',
  'merd',
  'meth',
  'mgger',
  'mggor',
  'mick',
  'mickeyfinn',
  'mideast',
  'mierda',
  'milf',
  'minge',
  'minger',
  'missionary',
  'missionary position',
  'mockey',
  'mockie',
  'mocky',
  'moky',
  'molest',
  'molestation',
  'molester',
  'molestor',
  'moneyshot',
  'mong',
  'moolie',
  'moon cricket',
  'moon crickets',
  'mooncricket',
  'mooncrickets',
  'mormon',
  'moron',
  'moskal',
  'moskals',
  'moslem',
  'mosshead',
  'motherfucka',
  'motherfvcker',
  'motherlovebone',
  'mothrfucker',
  'mound of venus',
  'moundofvenus',
  'mr hands',
  'mrhands',
  'mtherfucker',
  'mthrfuck',
  'mthrfucker',
  'mthrfucking',
  'mtrfck',
  'mtrfuck',
  'mtrfucker',
  'muffdive',
  'muffdiver',
  'muffdiving',
  'muffindiver',
  'mufflikcer',
  'muffpuff',
  'mulatto',
  'muncher',
  'mung',
  'munging',
  'munt',
  'munter',
  'murder',
  'murderer',
  'muthafuckaz',
  'muthafucker',
  'mutherfucking',
  'muthrfucking',
  'mzungu',
  'mzungus',
  'nad',
  'nads',
  'naked',
  'nambla',
  'napalm',
  'nappy',
  'nasty',
  'nastybitch',
  'nastyho',
  'nastyslut',
  'nastywhore',
  'nawashi',
  'nazism',
  'necked',
  'necro',
  'needthedick',
  'negres',
  'negress',
  'negro',
  'negroes',
  'negroid',
  'negros',
  'neonazi',
  'nig',
  'nig nog',
  'niga',
  'nigar',
  'nigars',
  'nigas',
  'nigers',
  'nigette',
  'nigettes',
  'nigg',
  'niggahs',
  'niggar',
  'niggaracci',
  'niggard',
  'niggarded',
  'niggarding',
  'niggardliness',
  'niggardlinesss',
  'niggardly',
  'niggards',
  'niggars',
  'niggerhead',
  'niggerhole',
  'niggle',
  'niggled',
  'niggles',
  'niggling',
  'nigglings',
  'niggor',
  'niggress',
  'niggresses',
  'nigguh',
  'nigguhs',
  'niggur',
  'niggurs',
  'niglet',
  'nignog',
  'nigor',
  'nigors',
  'nigr',
  'nigra',
  'nigras',
  'nigre',
  'nigres',
  'nigress',
  'nigs',
  'nigur',
  'niiger',
  'niigr',
  'nimphomania',
  'nimrod',
  'ninny',
  'nip',
  'nipple',
  'nipplering',
  'nipples',
  'nips',
  'nittit',
  'nlgger',
  'nlggor',
  'nofuckingway',
  'nog',
  'nookey',
  'nookie',
  'nooky',
  'noonan',
  'nooner',
  'nsfw',
  'nsfw images',
  'nude',
  'nudes',
  'nudger',
  'nudie',
  'nudies',
  'nudity',
  'nut sack',
  'nutbutter',
  'nutfucker',
  'nutten',
  'nymph',
  'nympho',
  'nymphomania',
  'o c k',
  'octopussy',
  'omorashi',
  'one cup two girls',
  'one guy',
  'one guy one jar',
  'one jar',
  'ontherag',
  'opiate',
  'opium',
  'oral',
  'orally',
  'orga',
  'organ',
  'orgasmic',
  'orgies',
  'orgy',
  'osama',
  'ovary',
  'ovum',
  'ovums',
  'p e n i s',
  'p i s',
  'p u s s y',
  'p.u.s.s.y.',
  'paddy',
  'paedophile',
  'pakis',
  'palesimian',
  'pancake face',
  'pancake faces',
  'panooch',
  'pansies',
  'pansy',
  'panti',
  'pantie',
  'panties',
  'panty',
  'paska',
  'pastie',
  'pasty',
  'payo',
  'pcp',
  'pearlnecklace',
  'peck',
  'peckerhead',
  'peckerwood',
  'pedo',
  'pedobear',
  'pedophile',
  'pedophilia',
  'pedophiliac',
  'pee',
  'peehole',
  'peepee',
  'peepshow',
  'peepshpw',
  'pegging',
  'pendejo',
  'pendy',
  'penetrate',
  'penetration',
  'peni5',
  'penial',
  'penile',
  'penises',
  'penisland',
  'penislick',
  'penislicker',
  'penispuffer',
  'penthouse',
  'perv',
  'perversion',
  'peyote',
  'phalli',
  'phallic',
  'phungky',
  'pi55',
  'picaninny',
  'piccaninny',
  'pickaninnies',
  'pickaninny',
  'pieceofshit',
  'piefke',
  'piefkes',
  'pierdol',
  'piker',
  'pikey',
  'piky',
  'pillowbiter',
  'pillu',
  'pimp',
  'pimped',
  'pimper',
  'pimpjuic',
  'pimpjuice',
  'pimpsimp',
  'pindick',
  'pinko',
  'pis',
  'pises',
  'pisin',
  'pising',
  'pisof',
  'pissflap',
  'pisshead',
  'pisspig',
  'pistol',
  'playboy',
  'playgirl',
  'pleasure chest',
  'pleasurechest',
  'pms',
  'pocha',
  'pochas',
  'pocho',
  'pochos',
  'pocketpool',
  'pohm',
  'pohms',
  'polacks',
  'pole smoker',
  'polesmoker',
  'pollock',
  'pollocks',
  'pommie',
  'pommie grant',
  'pommie grants',
  'pommies',
  'pommy',
  'ponyplay',
  'poo',
  'poof',
  'poon',
  'poonany',
  'poontang',
  'poopchute',
  'pooper',
  'pooperscooper',
  'pooping',
  'poorwhitetrash',
  'popimp',
  'porch monkey',
  'porch monkies',
  'porchmonkey',
  'pornflick',
  'pornking',
  'pornprincess',
  'pot',
  'potty',
  'pound town',
  'poundtown',
  'pplicker',
  'premature',
  'pric',
  'prickhead',
  'prig',
  'prince albert piercing',
  'propaganda',
  'prostitute',
  'prude',
  'pthc',
  'pu55i',
  'pu55y',
  'pubes',
  'pubic',
  'pubiclice',
  'pubis',
  'pud',
  'pudboy',
  'pudd',
  'puddboy',
  'puke',
  'punani',
  'punanny',
  'punany',
  'punkass',
  'punky',
  'punta',
  'puntang',
  'purinapricness',
  'pusies',
  'puss',
  'pussie',
  'pussycat',
  'pussydestroyer',
  'pussyeater',
  'pussyfart',
  'pussyfucker',
  'pussylicker',
  'pussylicking',
  'pussylips',
  'pussylover',
  'pussypalace',
  'pussypounder',
  'pusy',
  'quashie',
  'queaf',
  'queef',
  'queer',
  'queerbait',
  'queerhole',
  'queero',
  'queers',
  'queerz',
  'quickie',
  'quicky',
  'quiff',
  'quim',
  'qweers',
  'qweerz',
  'r-tard',
  'r-tards',
  'r5e',
  'ra8s',
  'racy',
  'raghead',
  'ragheads',
  'raging',
  'ragingboner',
  'randy',
  'rape',
  'raped',
  'raper',
  'raping',
  'rapist',
  'raunch',
  'rearend',
  'rearentry',
  'rectal',
  'rectus',
  'redleg',
  'redlegs',
  'redlight',
  'redneck',
  'rednecks',
  'redskin',
  'redskins',
  'reefer',
  'reestie',
  'reetard',
  'refugee',
  'reich',
  'renob',
  'rentafuck',
  'rere',
  'retarded',
  'retards',
  'retardz',
  'reverse cowgirl',
  'reversecowgirl',
  'revue',
  'rigger',
  'rimjob',
  'ritard',
  'rosebuds',
  'rosy palm',
  'rosy palm and her 5 sisters',
  'rosypalm',
  'rosypalmandher5sisters',
  'rosypalmandherefivesisters',
  'round eyes',
  'roundeye',
  'rtard',
  'rtards',
  'rum',
  'rump',
  'rumprammer',
  'ruski',
  'russki',
  'russkie',
  'rusty trombone',
  'rustytrombone',
  's h i t',
  's&m',
  's-h-1-t',
  's-h-i-t',
  's-o-b',
  's.h.i.t.',
  's.o.b.',
  's0b',
  'sac',
  'sadis',
  'sadism',
  'sadom',
  'sambo',
  'sambos',
  'samckdaddy',
  'sandm',
  'sandnigger',
  'santorum',
  'sausagequeen',
  'scag',
  'scallywag',
  'scantily',
  'scat',
  'scheiss',
  'schizo',
  'schvartse',
  'schvartsen',
  'schwartze',
  'schwartzen',
  'scissoring',
  'screwed',
  'screwyou',
  'scrog',
  'scrot',
  'scrud',
  'scum',
  'seaman',
  'seamen',
  'seduce',
  'seppo',
  'seppos',
  'septics',
  'sexcam',
  'sexed',
  'sexfarm',
  'sexhound',
  'sexhouse',
  'sexi',
  'sexing',
  'sexkitten',
  'sexo',
  'sexpot',
  'sexslave',
  'sextogo',
  'sextoy',
  'sextoys',
  'sexual',
  'sexually',
  'sexwhore',
  'sexx',
  'sexxi',
  'sexxx',
  'sexxxi',
  'sexxxy',
  'sexxy',
  'sexymoma',
  'sexyslim',
  'sh!+',
  'shamedame',
  'shat',
  'shav',
  'shaved',
  'shaved beaver',
  'shavedbeaver',
  'shavedpussy',
  'shawtypimp',
  'sheeney',
  'shhit',
  'shi+',
  'shibari',
  'shibary',
  'shinola',
  'shitass',
  'shitbag',
  'shitbagger',
  'shitblimp',
  'shitbrain',
  'shitbreath',
  'shitcan',
  'shitcunt',
  'shiteater',
  'shiteating',
  'shitface',
  'shitfaced',
  'shitfit',
  'shitforbrains',
  'shitfucker',
  'shithapens',
  'shithappens',
  'shitheel',
  'shithole',
  'shithouse',
  'shitlist',
  'shitload',
  'shitola',
  'shitoutofluck',
  'shitpot',
  'shitspitter',
  'shitstain',
  'shitt',
  'shittiest',
  'shiznit',
  'shortfuck',
  'shota',
  'shrimping',
  'shylock',
  'shylocks',
  'simp',
  'sissy',
  'sixsixsix',
  'sixtynine',
  'sixtyniner',
  'skag',
  'skankbitch',
  'skankfuck',
  'skankwhore',
  'skankybitch',
  'skankywhore',
  'skeet',
  'skinflute',
  'skullfuck',
  'skum',
  'skumbag',
  'skwa',
  'skwe',
  'slant',
  'slanteye',
  'slanty',
  'slapper',
  'slaughter',
  'slave',
  'slavedriver',
  'sleaze',
  'sleazy',
  'sleezebag',
  'sleezeball',
  'slideitin',
  'slimeball',
  'slimebucket',
  'slopehead',
  'slopeheads',
  'sloper',
  'slopers',
  'slopes',
  'slopey',
  'slopeys',
  'slopies',
  'slopy',
  'slutbag',
  'slutbucket',
  'slutdumper',
  'slutkiss',
  'slutt',
  'slutting',
  'slutwear',
  'slutwhore',
  'smack',
  'smackthemonkey',
  'smeg',
  'smoker',
  'smutty',
  'snatchpatch',
  'snigger',
  'sniggered',
  'sniggering',
  'sniggers',
  'sniper',
  'snowback',
  'snowballing',
  'snownigger',
  'snuff',
  'sob',
  'socksucker',
  'sodom',
  'sodomise',
  'sodomite',
  'sodomize',
  'sodomy',
  'sonofabitch',
  'sonofbitch',
  'sooties',
  'sooty',
  'souse',
  'soused',
  'soyboy',
  'spade',
  'spades',
  'spaghettibender',
  'spaghettinigger',
  'spank',
  'spankthemonkey',
  'spastic',
  'spearchucker',
  'spearchuckers',
  'sperm',
  'spermacide',
  'spermbag',
  'spermhearder',
  'spermherder',
  'spick',
  'spicks',
  'spics',
  'spig',
  'spigotty',
  'spik',
  'spiks',
  'spitter',
  'splittail',
  'spludge',
  'spooge',
  'spread legs',
  'spreadeagle',
  'spunky',
  'sqeh',
  'squa',
  'squarehead',
  'squareheads',
  'squaw',
  'squinty',
  'squirting',
  'stagg',
  'steamy',
  'stfu',
  'stiffy',
  'stoned',
  'stoner',
  'strap on',
  'strapon',
  'strappado',
  'stringer',
  'strip',
  'strip club',
  'stripclub',
  'stroke',
  'stroking',
  'stuinties',
  'stupid',
  'stupidfuck',
  'stupidfucker',
  'style doggy',
  'suck',
  'suckdick',
  'sucked',
  'sucker',
  'sucking',
  'suckme',
  'suckmyass',
  'suckmydick',
  'suckmytit',
  'suckoff',
  'sucks',
  'suicide',
  'suicide girl',
  'suicide girls',
  'suicidegirl',
  'suicidegirls',
  'sultry',
  'sultry women',
  'sultrywoman',
  'sultrywomen',
  'sumofabiatch',
  'swallow',
  'swallower',
  'swalow',
  'swamp guinea',
  'swamp guineas',
  'swastika',
  'swinger',
  'syphilis',
  't i t',
  't i ts',
  't1t',
  'taboo',
  'tacohead',
  'tacoheads',
  'taff',
  'tainted',
  'tainted love',
  'take off your',
  'tampon',
  'tantra',
  'tar babies',
  'tar baby',
  'tarbaby',
  'tard',
  'taste my',
  'tastemy',
  'tawdry',
  'tea bagging',
  'teabagging',
  'teat',
  'terd',
  'terror',
  'terrorist',
  'teste',
  'testee',
  'testes',
  'testicles',
  'testis',
  'thicklip',
  'thicklips',
  'thirdeye',
  'thirdleg',
  'threesome',
  'threeway',
  'throat',
  'throating',
  'thrust',
  'thug',
  'thumbzilla',
  'thundercunt',
  'ti',
  'tied up',
  'tig ol bitties',
  'tig old bitties',
  'tight white',
  'timbernigger',
  'tinkle',
  'titbitnipply',
  'titfucker',
  'titfuckin',
  'titi',
  'titjob',
  'titlicker',
  'titlover',
  'tittie',
  'tittis',
  'titty',
  'tittyfucker',
  'tittys',
  'tity',
  'to murder',
  'toke',
  'tongethruster',
  'tongue in a',
  'tongueina',
  'tonguethrust',
  'tonguetramp',
  'toots',
  'topless',
  'tortur',
  'torture',
  'towel head',
  'towel heads',
  'towelhead',
  'trailertrash',
  'tramp',
  'trannie',
  'tranny',
  'transsexual',
  'transvestite',
  'trashy',
  'tribadism',
  'triplex',
  'trisexual',
  'trois',
  'trojan',
  'trombone',
  'trots',
  'tub girl',
  'tubgirl',
  'tuckahoe',
  'tunneloflove',
  'turnon',
  'tush',
  'tushy',
  'twatlips',
  'twats',
  'twatwaffle',
  'twink',
  'twinkie',
  'two girls one cup',
  'twobitwhore',
  'udge packer',
  'ugly',
  'ukrop',
  'unclefucker',
  'undies',
  'undressing',
  'unfuckable',
  'unwed',
  'upskirt',
  'uptheass',
  'upthebutt',
  'urethra',
  'urethra play',
  'urethraplay',
  'urinal',
  'urine',
  'urophilia',
  'usama',
  'ussys',
  'uterus',
  'uzi',
  'v a g i n a',
  'v4gra',
  'va-j-j',
  'vag',
  'vaginal',
  'valium',
  'venus mound',
  'vgra',
  'vibe',
  'vibr',
  'vibrater',
  'vibrator',
  'vigra',
  'violet wand',
  'virgin',
  'virginbreaker',
  'vixen',
  'vjayjay',
  'vodka',
  'vomit',
  'vorarephilia',
  'voyeur',
  'voyeurweb',
  'voyuer',
  'vulgar',
  'wab',
  'wad',
  'wanking',
  'waysted',
  'wazoo',
  'wedgie',
  'weed',
  'weenie',
  'weewee',
  'weiner',
  'weirdo',
  'welcher',
  'wench',
  'wet dream',
  'wetb',
  'wetback',
  'wetbacks',
  'wetdream',
  'wetspot',
  'wh0reface',
  'whacker',
  'whash',
  'whigger',
  'whiggers',
  'whiskeydick',
  'whiskydick',
  'whit',
  'white power',
  'white trash',
  'whitenigger',
  'whitepower',
  'whites',
  'whitetrash',
  'whitey',
  'whiteys',
  'whities',
  'whiz',
  'whop',
  'whoralicious',
  'whorealicious',
  'whorebag',
  'whored',
  'whoreface',
  'whorefucker',
  'whorehopper',
  'whorehouse',
  'whores',
  'whoring',
  'wigga',
  'wiggas',
  'wigger',
  'wiggers',
  'willie',
  'williewanker',
  'wn',
  'wog',
  'wogs',
  'womb',
  'woody',
  'woose',
  'wop',
  'worldsex',
  'wrapping men',
  'wrinkled starfish',
  'wtf',
  'wuss',
  'wuzzie',
  'x-rated',
  'x-rated2g1c',
  'xkwe',
  'xtc',
  'xx',
  'xxxxxx',
  'yank',
  'yaoi',
  'yarpie',
  'yarpies',
  'yeasty',
  'yellow showers',
  'yellowman',
  'yellowshowers',
  'yid',
  'yids',
  'yiffy',
  'yobbo',
  'yourboobs',
  'yourpenis',
  'yourtits',
  'yury',
  'zigabo',
  'zigabos',
  'zipperhead',
  'zipperheads',
  'zoophile',
  'zoophilia',
  '🖕',
];
